define(function (require, exports, module) {
    function extractSplits (player) {
        var statsByGameTypeBucket = {};
        if (player.stats && player.stats.length > 0) {
            for (var i = 0; i < player.stats.length; i++) {
                var statsSplits = player.stats[i].splits || [];

                if (statsSplits.length > 0) {
                    statsSplits.forEach(function (statSplit) {
                        const group = (statSplit.numTeams) ? 'total' : statSplit.gameType;
                        if (group) {
                            statsByGameTypeBucket[group] = statSplit.stat;
                            if (!this[player.id]) {
                                this[player.id] = {};
                            }
                            this[player.id][group] = statSplit.stat;
                        }
                    }, this);
                } else if (statsSplits.length === 1) {
                    this[player.id] = statsSplits[0].stat;
                } else {
                    this[player.id] = null;
                }
            }
        }
    }

    function TeamLineupHittingStatsModel (data) {
        this.players = {};
        if (data) {
            this.parseData(data);
        }
    }

    TeamLineupHittingStatsModel.prototype = {
        parseData: function (data) {
            var players = this.players;
            data.people.forEach(extractSplits, players);
        }
    };

    return TeamLineupHittingStatsModel;
});
